"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var tabs = [
    {
        name: 'TabVideowallSettings',
        label: 'Settings',
    },
];
function Iframe(_a) {
    var url = _a.url;
    storybook_1.Hooks.useScript(url, 'videowall-iframe');
    return react_1.default.createElement("div", { id: 'videowall-iframe', style: { height: '100%', width: '100%' } });
}
function Videowall(_a) {
    var id = _a.id;
    var channel = ra_fetch_1.useApi('backend').show('channels', { id: id, details: true, channel_id: id })[0];
    var _b = react_1.useState(tabs[0].name), tab = _b[0], setTab = _b[1];
    var Tab = storybook_1.Channels[tab];
    if (channel.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!channel.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    var url = process.env.NEXT_PUBLIC_STORYBOOK_WALL_URL + "/js/wall.min.js?channel=" + channel.data.name;
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space storybook-pages-showcase' },
        react_1.default.createElement("div", { className: 'storybook-pages-showcase-form' },
            react_1.default.createElement(Tab, { url: url })),
        react_1.default.createElement("div", { className: 'storybook-pages-showcase-preview' },
            react_1.default.createElement(Iframe, { url: url })));
}
exports.default = Videowall;
Videowall.propTypes = {
    channel: prop_types_1.default.object,
};
Videowall.defaultProps = {};
